import { ActivatedRouteSnapshot, Route, Routes } from '@angular/router';
import { MedicosContent } from './medicos-content';
import { DashboardMedicos } from '@/features/registro/medicos/dashboard-medicos/dashboard-medicos';
import { medicoRelatoriosRoutes } from '@/features/registro/medicos/relatorios/medico-relatorios.routes';
import { MEDICOS_ROUTES } from './medicos.constants';
import { permissionGuard } from '@/core/permissions/permission.guard';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';
import { PermissionInput } from '@/core/permissions/permission.model';

const I = MEDICOS_ROUTES.ITEM;
const P = PERMISSOES.medicos;

/**
 * Uma rota por funcionalidade (21 slugs → 17 escopos: visto-temporário tem 2 slugs,
 * central de transferências tem 5). O slug vai em `data.codigo` — o `DashboardMedicos`
 * o lê de lá para escolher a aba (com fallback para paramMap, por links antigos).
 */
const ABAS: ReadonlyArray<{ slug: string; permission: PermissionInput }> = [
    { slug: I.DADOS_REGISTRO, permission: P.dadosRegistro.escopo },
    { slug: I.BIOMETRIA, permission: P.biometria.escopo },
    { slug: I.CONTATOS, permission: P.contato.escopo },
    { slug: I.DOCUMENTOS, permission: P.documentos.escopo },
    { slug: I.FORMACAO, permission: P.formacao.escopo },
    { slug: I.ESPECIALIDADE, permission: P.especialidade.escopo },
    { slug: I.HISTORICO, permission: P.historico.escopo },
    { slug: I.FUNCOES, permission: P.funcoes.escopo },
    { slug: I.ANOTACOES, permission: P.anotacoes.escopo },
    { slug: I.CONSULTORIO_PRIVADO, permission: P.consultorio.escopo },
    { slug: I.TELEMEDICINA, permission: P.telemedicina.escopo },
    { slug: I.PCMSO, permission: P.pcmso.escopo },
    { slug: I.CONFLITO_INTERESSE, permission: P.conflitoInteresse.escopo },
    { slug: I.VISTO_TEMPORARIO_LOCALIZAR, permission: P.vistoTemporario.escopo },
    { slug: I.VISTO_TEMPORARIO_NOVO, permission: P.vistoTemporario.escopo },
    { slug: I.CT_SOLICITAR, permission: P.centralTransferencia.escopo },
    { slug: I.CT_LOCALIZAR_CPF, permission: P.centralTransferencia.escopo },
    { slug: I.CT_ABERTAS_UF_ORIGEM, permission: P.centralTransferencia.escopo },
    { slug: I.CT_ABERTAS_UF_DESTINO, permission: P.centralTransferencia.escopo },
    { slug: I.CT_AGUARDANDO_ENCERRAMENTO, permission: P.centralTransferencia.escopo },
    { slug: I.DOCUMENTOS_EMISSAO, permission: P.emissaoValid.escopo }
];

const rotaAba = (aba: { slug: string; permission: PermissionInput }): Route => ({
    path: `${MEDICOS_ROUTES.ITEM_BASE}/${aba.slug}`,
    component: DashboardMedicos,
    canActivate: [permissionGuard],
    resolve: { breadcrumb: (route: ActivatedRouteSnapshot) => route.fragment },
    data: { breadcrumb: null, codigo: aba.slug, permission: aba.permission }
});

/**
 * Rotas do módulo de Médicos: layout `MedicosContent` na raiz `medicos`, com o
 * `DashboardMedicos` na rota padrão, uma rota por aba e os relatórios.
 * A raiz NÃO é gateada (o dashboard é a busca, não uma funcionalidade).
 */
export const medicosRoutes: Routes = [
    {
        path: MEDICOS_ROUTES.ROOT,
        component: MedicosContent,
        data: { breadcrumb: 'Médicos' },
        children: [{ path: MEDICOS_ROUTES.DASHBOARD, component: DashboardMedicos }, ...ABAS.map(rotaAba), ...medicoRelatoriosRoutes]
    }
];
